import { createStore } from "@stencil/store";
import { Content, EMPTY_CONTENT } from "../entities/content";

export const navContentStore = createStore<Content>(EMPTY_CONTENT);
